/* ULMO REDESIGN — Side-tile zoom (Ulmo Difference comparison).
   Progressively enhances .u-featured-side-tile so tapping opens a
   bento-style modal with the high-res image instead of navigating
   to the product page. Self-contained: injects its own CSS + modal
   markup. Safe to load on every page. */
(function(){
  'use strict';

  var CSS = '' +
    '.u-featured-side-tile a, .u-featured-side-tile button { cursor: zoom-in; }' +
    '.u-side-tile-modal { position: fixed; inset: 0; z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 16px; opacity: 0; pointer-events: none; transition: opacity 0.25s ease; }' +
    '.u-side-tile-modal.is-open { opacity: 1; pointer-events: auto; }' +
    '.u-side-tile-modal__backdrop { position: absolute; inset: 0; background: rgba(27,46,42,0.65); -webkit-backdrop-filter: blur(8px); backdrop-filter: blur(8px); }' +
    '.u-side-tile-modal__panel { position: relative; background: #FFFFFF; border-radius: 20px; max-width: min(980px, calc(100vw - 24px)); max-height: calc(100vh - 32px); overflow: auto; padding: 18px; box-shadow: 0 20px 60px rgba(0,0,0,0.28); z-index: 1; transform: scale(0.94); transition: transform 0.25s cubic-bezier(0.22,0.61,0.36,1); }' +
    '.u-side-tile-modal.is-open .u-side-tile-modal__panel { transform: scale(1); }' +
    '.u-side-tile-modal__image { display: block; width: 100%; height: auto; border-radius: 12px; }' +
    '.u-side-tile-modal__close { position: absolute; top: 10px; right: 10px; width: 38px; height: 38px; border-radius: 50%; background: rgba(255,255,255,0.96); border: 1px solid rgba(27,46,42,0.12); display: inline-flex; align-items: center; justify-content: center; cursor: pointer; color: #1B2E2A; z-index: 2; box-shadow: 0 2px 6px rgba(0,0,0,0.1); padding: 0; }' +
    '.u-side-tile-modal__close:hover { background: #FFFFFF; }' +
    '@media (max-width: 749px) { .u-side-tile-modal__panel { padding: 10px; border-radius: 16px; } .u-side-tile-modal__close { width: 34px; height: 34px; top: 8px; right: 8px; } }';

  function injectStyles(){
    if (document.getElementById('u-side-tile-zoom-styles')) return;
    var s = document.createElement('style');
    s.id = 'u-side-tile-zoom-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function buildModal(){
    var existing = document.getElementById('u-side-tile-modal');
    if (existing) return existing;
    var m = document.createElement('div');
    m.id = 'u-side-tile-modal';
    m.className = 'u-side-tile-modal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-hidden', 'true');
    m.innerHTML =
      '<div class="u-side-tile-modal__backdrop" data-close></div>' +
      '<div class="u-side-tile-modal__panel" role="document">' +
        '<button type="button" class="u-side-tile-modal__close" aria-label="Close" data-close>' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<img class="u-side-tile-modal__image" src="" alt="">' +
      '</div>';
    document.body.appendChild(m);
    return m;
  }

  function pickLargestSrc(img){
    if (img.srcset) {
      var parts = img.srcset.split(',').map(function(s){
        var bits = s.trim().split(/\s+/);
        return { url: bits[0], w: parseInt(bits[1] || '0', 10) || 0 };
      });
      parts.sort(function(a,b){ return b.w - a.w; });
      if (parts[0] && parts[0].url) return parts[0].url;
    }
    return img.currentSrc || img.src;
  }

  function bind(tile, modal, modalImage){
    var img = tile.querySelector('img');
    if (!img) return;
    var link = tile.querySelector('a');
    var trigger = link || tile;
    trigger.addEventListener('click', function(e){
      e.preventDefault();
      modalImage.src = pickLargestSrc(img);
      modalImage.alt = img.alt || 'Comparison';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  function init(){
    var tiles = document.querySelectorAll('.u-featured-side-tile');
    if (!tiles.length) return;
    injectStyles();
    var modal = buildModal();
    var modalImage = modal.querySelector('.u-side-tile-modal__image');
    var closeEls = modal.querySelectorAll('[data-close]');
    function close(){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    closeEls.forEach(function(el){ el.addEventListener('click', close); });
    if (!modal.dataset.bound) {
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      });
      modal.dataset.bound = '1';
    }
    tiles.forEach(function(t){
      if (t.dataset.zoomBound) return;
      bind(t, modal, modalImage);
      t.dataset.zoomBound = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
